module.exports = __webpack_public_path__ + "static/media/ModilectIntegritetspolicy.102b6aee.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Legal/ModilectIntegritetspolicy.pdf
// module id = 334
// module chunks = 0